export default {
  ADD_EVENT: 'ADD_EVENT',
  DELETE_EVENT: 'DELETE_EVENT',
  EDIT_EVENT: 'EDIT_EVENT',
  UPDATE_FULL_EVENTS: 'UPDATE_FULL_EVENTS',
  RESET_EVENTS: 'RESET_EVENTS'
};
